export const isIntraDomain = (): boolean =>
  window.location.hostname.includes('.intra.');
